import { create } from "zustand";

export const useNotoficationStore = create((set) => ({
    notification:[],
    newNotification:0,
    updateNotification:(data)=>{
      let is_seen_count=0
      data?.forEach((val)=>{
        if(val?.is_seen===false){
          is_seen_count+=1
        }
      })
      set({notification:data,newNotification:is_seen_count})
    }
  }));